var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import MetadataApi from '~/api/metadata';
import { toCamel } from '~/utils/toCamelCase';
const convertMetadata = (fileEnt, metadataDict) => {
    const fileMetadata = {
        file: fileEnt,
        metadataFields: [],
    };
    for (const [index, val] of Object.entries(metadataDict)) {
        const newKey = index.toLowerCase().replace(/\s/g, '_');
        fileMetadata.metadataFields.push({ name: toCamel(newKey), value: val });
    }
    return fileMetadata;
};
const getClauseParentMetadata = (clauseParentMetadata, clause) => __awaiter(void 0, void 0, void 0, function* () {
    const fileMetadata = [...clauseParentMetadata];
    for (const parentDoc of clause.source.parentDocuments) {
        if (fileMetadata.findIndex(fm => fm.file.id === parentDoc.id) === -1) {
            const metadata = yield MetadataApi.getById(parentDoc.id);
            fileMetadata.push(convertMetadata(parentDoc, metadata));
        }
    }
    return fileMetadata;
});
export default getClauseParentMetadata;
